export default "__VITE_ASSET__D0fE50Pm__";